<div class="planner bg-gray-100">
  <div class="p-4 flex justify-between border border-b bg-white">
    <span
      matTooltip="Cancel"
      class="hover:bg-gray-100 text-gray-400 cursor-pointer rounded-full text-sm w-[28px] h-[28px] flex justify-center items-center"
      (click)="closeWithConfirmationIfNeeded()"
    >
      <mat-icon class="align-middle text-blue-500">close</mat-icon>
    </span>
    <h1 *ngIf="state === 'plan-editor'" class="font-medium">Planner</h1>

    <span *ngIf="authService.isPro; else freeUser" class="hidden sm:block">
      <div
        *ngIf="!isSaving; else proSpinner"
        matTooltip="Save"
        class="hover:bg-gray-100 text-gray-400 cursor-pointer rounded-full text-sm w-[28px] h-[28px] flex justify-center items-center"
        (click)="save()"
      >
        <mat-icon class="align-middle text-blue-500">check</mat-icon>
      </div>
      <ng-template #proSpinner>
        <mat-spinner [diameter]="20" class="grayscale opacity-50"></mat-spinner>
      </ng-template>
    </span>
    <ng-template #freeUser>
      <span *ngIf="isLimitedByProFeatures(); else freeSave">
        <pro-badge
          [tooltip]="'Save with Prefund Pro'"
          [color]="'blue-500'"
        ></pro-badge>
      </span>

      <ng-template #freeSave>
        <div
          *ngIf="!isSaving; else freeSpinner"
          matTooltip="Save"
          class="hover:bg-gray-100 text-gray-400 cursor-pointer rounded-full text-sm w-[28px] h-[28px] flex justify-center items-center"
          (click)="save()"
        >
          <mat-icon class="align-middle text-blue-500">check</mat-icon>
        </div>
        <ng-template #freeSpinner>
          <mat-spinner
            [diameter]="20"
            class="grayscale opacity-50"
          ></mat-spinner>
        </ng-template>
      </ng-template>
    </ng-template>
  </div>

  <mat-dialog-content class="no-scrollbar">
    <div class="sm:hidden">
      <span
        >Planner is not yet available on mobile view. Please open Prefund on a
        desktop device to open the Planner.</span
      >
    </div>
    <div class="hidden sm:block">
      <!-- Editor -->
      <div *ngIf="state === 'plan-editor'">
        <div>
          <div class="overflow-hidden bg-white">
            <table class="w-full border-separate border-spacing-0">
              <tbody>
                <tr
                  class="uppercase bg-gray-100 hover:bg-gray-200 text-gray-500"
                >
                  <td
                    class="border-b min-w-[{{
                      defaultCellWidth
                    }}] cursor-pointer"
                    (click)="toggleFixedTags()"
                  >
                    <mat-icon class="align-middle" *ngIf="expandFixedTags"
                      >keyboard_arrow_down</mat-icon
                    >
                    <mat-icon class="align-middle" *ngIf="!expandFixedTags"
                      >keyboard_arrow_up</mat-icon
                    >
                    Fixed tags
                  </td>
                  <td
                    class="border-b min-w-[{{ defaultCellWidth }}] text-center"
                  >
                    <span
                      *ngIf="
                        expandFixedTags && getNewFixedTags(newTags).length > 0
                      "
                      >Plans</span
                    >
                  </td>
                  <td
                    class="border-b min-w-[{{
                      defaultMiniCellWidth
                    }}] text-center"
                  ></td>
                  <td class="border-b text-center">
                    <span
                      *ngIf="
                        expandFixedTags && getNewFixedTags(newTags).length > 0
                      "
                      >Actions</span
                    >
                  </td>
                </tr>
                <ng-content *ngIf="expandFixedTags">
                  <ng-content *ngIf="getNewFixedTags(newTags).length > 0">
                    <ng-content
                      *ngFor="
                        let tag of getNewFixedTags(newTags);
                        trackBy: trackByTagId
                      "
                    >
                      <tr class="p-4" [ngClass]="getRowClass(tag)">
                        <td>
                          <span class="rounded-md" [ngClass]="getTagClass(tag)">
                            <input
                              id="{{ tag.fullPath }}"
                              [ngClass]="getColorClassFor(tag)"
                              class="!m-0 {{
                                isTopLevel(tag) ? '!rounded-r-none' : ''
                              }}"
                              type="text"
                              placeholder="Tag name..."
                              *ngIf="!tag.isArchived"
                              [value]="tag.fullPath.split('/').splice(-1)"
                              (input)="updateNameAndChildrenName(tag, $event)"
                            />
                          </span>
                          <select
                            matTooltip="Color"
                            class="grow h-[32px] cursor-pointer !border-x-0 !rounded-none"
                            *ngIf="isTopLevel(tag)"
                            [value]="tag.color || 'green'"
                            [ngClass]="getColorClassFor(tag)"
                            (change)="updateColor(tag, $event)"
                            name="color"
                            id="color"
                          >
                            <option value="green">🟢</option>
                            <option value="orange">🟠</option>
                            <option value="red">
                              {{ authService.isPro ? "🔴" : "🔴 (Pro)" }}
                            </option>
                            <option value="blue">
                              {{ authService.isPro ? "🔵" : "🔵 (Pro)" }}
                            </option>
                            <option value="yellow">
                              {{ authService.isPro ? "🟡" : "🟡 (Pro)" }}
                            </option>
                            <option value="purple">
                              {{ authService.isPro ? "🟣" : "🟣 (Pro)" }}
                            </option>

                            <option value="white">
                              {{ authService.isPro ? "⚪" : "⚪ (Pro)" }}
                            </option>
                          </select>
                          <mat-form-field
                            matTooltip="Summary type"
                            *ngIf="isTopLevel(tag)"
                            class="w-[70px] h-[32px] {{
                              getColorClassFor(tag)
                            }} {{
                              getTagColor(tag, newTags)
                            }} translate-y-[3px]"
                          >
                            <mat-select
                              (selectionChange)="updateSummary(tag, $event)"
                              panelClass="wide-panel {{
                                getTagColor(tag, newTags)
                              }} !border-{{ getTagColor(tag, newTags) }}-400"
                              [value]="tag?.summary?.toString() ?? 'none'"
                            >
                              <mat-select-trigger class="!w-[40px]"
                                ><mat-icon class="translate-y-[4px]">
                                  {{ getSummaryIcon(tag, newTags) }}
                                </mat-icon></mat-select-trigger
                              >
                              <mat-option [value]="'expenditureProgress'">
                                <div class="py-2 flex">
                                  <mat-icon
                                    class="align-middle translate-y-[5px]"
                                  >
                                    shopping_bag
                                  </mat-icon>
                                  <div>
                                    <span class="block font-medium"
                                      >Expenditure progress</span
                                    >
                                    <span
                                      >Plan and track your expenditure. Ideal
                                      for budgets.</span
                                    >
                                  </div>
                                </div>
                              </mat-option>
                              <mat-option [value]="'incomeProgress'">
                                <div class="py-2 flex">
                                  <mat-icon
                                    class="align-middle translate-y-[5px]"
                                  >
                                    savings
                                  </mat-icon>
                                  <div>
                                    <span class="block font-medium"
                                      >Income progress</span
                                    >
                                    <span
                                      >Plan and track your income. Ideal for
                                      businesses.</span
                                    >
                                  </div>
                                </div>
                              </mat-option>
                              <mat-option [value]="'runningBalance'">
                                <div class="py-2 flex">
                                  <mat-icon
                                    class="align-middle translate-y-[5px]"
                                  >
                                    balance
                                  </mat-icon>
                                  <div>
                                    <span class="block font-medium"
                                      >Running balance</span
                                    >
                                    <span
                                      >Track your running balance. Ideal for
                                      accounts.</span
                                    >
                                  </div>
                                </div>
                              </mat-option>
                              <mat-option [value]="'none'">
                                <div class="py-2 flex">
                                  <mat-icon
                                    class="align-middle translate-y-[5px]"
                                  >
                                    tag
                                  </mat-icon>
                                  <div>
                                    <span class="block font-medium"
                                      >No summary</span
                                    >
                                    <span>Keep calm and stay quiet</span>
                                  </div>
                                </div>
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>

                        <td class="text-center">
                          <!-- Expenditure input -->

                          <div
                            class="text-center"
                            [hidden]="
                              getTagSummary(tag, newTags) !==
                                'expenditureProgress' || tag.isArchived
                            "
                          >
                            <input
                              id="planned-expenditure-{{ tag.id }}"
                              type="text"
                              placeholder="Planned expenditure"
                              [value]="tag.plannedExpenditure || null"
                              (input)="updatePlanned(tag, $event)"
                            />
                          </div>

                          <!-- Income input -->
                          <div
                            [hidden]="
                              getTagSummary(tag, newTags) !==
                                'incomeProgress' || tag.isArchived
                            "
                          >
                            <!-- <div [hidden]="true"> -->
                            <input
                              id="planned-income-{{ tag.id }}"
                              type="text"
                              placeholder="Planned income"
                              [value]="tag.plannedIncome || null"
                              (input)="updatePlanned(tag, $event)"
                            />
                          </div>
                          <span
                            class="text-gray-400 text-center"
                            *ngIf="
                              !tag.isArchived &&
                              (!getTopLevelTag(tag)?.summary ||
                                getTopLevelTag(tag)?.summary === 'none' ||
                                getTopLevelTag(tag)?.summary ===
                                  'runningBalance')
                            "
                          >
                            <span class="text-center">Nothing to plan</span>
                          </span>
                        </td>

                        <td>
                          <!-- Expenditure progress -->
                          <span
                            *ngIf="true"
                            [hidden]="
                              !hasChildren(tag) ||
                              tag.fullPath === '' ||
                              getTagSummary(tag, newTags) !==
                                'expenditureProgress'
                            "
                            class="text-gray-400 text-xs"
                            [ngClass]="{
                              'text-orange-500':
                                getChildrenTotal(tag) >
                                getPlannedExpenditure(tag)
                            }"
                            ><span
                              class="max-w-[9rem] truncate inline-block align-middle"
                              matTooltip="The total sum of subtag plans"
                            >
                              <span
                                (click)="
                                  tag.plannedExpenditure = getChildrenTotal(tag)
                                "
                                [ngClass]="{
                                  'underline cursor-pointer decoration-dashed':
                                    getChildrenTotal(tag) >
                                    getPlannedExpenditure(tag)
                                }"
                                >Subtag total:
                                {{
                                  getChildrenTotal(tag) | prefundCurrency
                                }}</span
                              ></span
                            ></span
                          >

                          <!-- INcome progress -->
                          <span
                            [hidden]="
                              !hasChildren(tag) ||
                              tag.fullPath === '' ||
                              getTagSummary(tag, newTags) !== 'incomeProgress'
                            "
                            class="text-gray-400 text-xs"
                            [ngClass]="{
                              'text-orange-500':
                                getChildrenTotal(tag) > getPlannedIncome(tag)
                            }"
                            ><span
                              class="max-w-[9rem] truncate inline-block align-middle"
                              matTooltip="The total sum of subtag plans"
                            >
                              <span
                                (click)="
                                  tag.plannedIncome = getChildrenTotal(tag)
                                "
                                [ngClass]="{
                                  'underline cursor-pointer decoration-dashed':
                                    getChildrenTotal(tag) >
                                    getPlannedIncome(tag)
                                }"
                              >
                                Subtag total:
                                {{ getChildrenTotal(tag) | number : "." }}</span
                              ></span
                            ></span
                          >
                        </td>

                        <td class="flex justify-end">
                          <mat-icon
                            class="text-gray-400 cursor-pointer mr-2"
                            matTooltip="Add subtag"
                            (click)="addChild(tag)"
                            >add</mat-icon
                          >
                          <mat-icon
                            class="text-gray-400 cursor-pointer mr-2"
                            matTooltip="Move up"
                            (click)="moveUp(tag)"
                            >arrow_upward</mat-icon
                          >
                          <mat-icon
                            class="text-gray-400 cursor-pointer mr-2"
                            matTooltip="Move down"
                            (click)="moveDown(tag)"
                            >arrow_downward</mat-icon
                          >

                          <mat-icon
                            class="text-gray-400 cursor-pointer"
                            matTooltip="More"
                            [matMenuTriggerFor]="menu"
                            >more_vert</mat-icon
                          >
                          <mat-menu #menu="matMenu">
                            <button
                              mat-menu-item
                              (click)="duplicate(tag)"
                              *ngIf="!tag.isArchived && tag.id"
                            >
                              <mat-icon>content_copy</mat-icon> Duplicate
                            </button>
                            <button
                              mat-menu-item
                              (click)="archive(tag)"
                              *ngIf="!tag.isArchived"
                            >
                              <mat-icon>archive</mat-icon> Archive
                            </button>
                            <button
                              mat-menu-item
                              (click)="archive(tag, false)"
                              *ngIf="tag.isArchived"
                            >
                              <mat-icon>unarchive</mat-icon> Unarchive
                            </button>
                            <button mat-menu-item (click)="deleteTag(tag)">
                              <mat-icon>delete</mat-icon> Delete
                            </button>
                          </mat-menu>
                        </td>
                      </tr>
                    </ng-content>
                  </ng-content>

                  <tr *ngIf="getNewFixedTags(newTags).length > 0">
                    <td class="p-10">
                      <span
                        class="cursor-pointer text-blue-500"
                        (click)="addTag()"
                        >New Fixed Tag...
                      </span>
                    </td>
                  </tr>
                </ng-content>
              </tbody>
            </table>

            <planner-empty-state
              *ngIf="expandFixedTags && getNewFixedTags(newTags).length === 0"
              [title]="'Create a Fixed Tag'"
              [description]="'Fixed Tags have fixed summaries.'"
              [descriptionSecondLine]="
                'Ideal for tracking accounts or one-time projects.'
              "
              [callToActionText]="'New Fixed Tag...'"
              (callToActionClick)="addTag()"
            ></planner-empty-state>

            <table class="w-full border-separate border-spacing-0">
              <tbody>
                <tr
                  class="uppercase bg-gray-100 hover:bg-gray-200 text-gray-500"
                >
                  <td
                    class="border-y min-w-[{{
                      defaultCellWidth
                    }}] cursor-pointer"
                    (click)="togglePeriodicTags()"
                  >
                    <mat-icon class="align-middle" *ngIf="expandPeriodicTags"
                      >keyboard_arrow_down</mat-icon
                    >
                    <mat-icon class="align-middle" *ngIf="!expandPeriodicTags"
                      >keyboard_arrow_up</mat-icon
                    >
                    <span class="mr-4 align-middle">Periodic tags</span>
                    <pro-badge *ngIf="!authService.isPro"></pro-badge>
                  </td>
                  <td
                    class="border-y text-center min-w-[{{ defaultCellWidth }}]"
                  >
                    <span
                      *ngIf="
                        expandPeriodicTags &&
                        getPeriodicNewTags(newTags).length > 0
                      "
                    >
                      <span class="mr-2">Plans for </span>
                      <span>
                        <mat-icon
                          class="cursor-pointer align-middle scale-[.6]"
                          (click)="periodService.previous()"
                          >arrow_back_ios</mat-icon
                        >
                        <span
                          >{{ periodService.current.year }} /
                          {{ periodService.current.month }}</span
                        >
                        <mat-icon
                          class="cursor-pointer align-middle scale-[.6]"
                          (click)="periodService.next()"
                          >arrow_forward_ios</mat-icon
                        >
                      </span>
                    </span>
                  </td>
                  <td
                    class="border-y text-center min-w-[{{
                      defaultMiniCellWidth
                    }}]"
                  ></td>
                  <td class="border-y text-center">
                    <span
                      *ngIf="
                        expandPeriodicTags &&
                        getPeriodicNewTags(newTags).length > 0
                      "
                      >Actions</span
                    >
                  </td>
                </tr>

                <ng-content *ngIf="expandPeriodicTags">
                  <ng-content
                    *ngFor="
                      let tag of getPeriodicNewTags(newTags);
                      trackBy: trackByTagId
                    "
                  >
                    <tr
                      class="p-4"
                      [ngClass]="getRowClass(tag)"
                      *ngIf="!tag.isArchived || true"
                    >
                      <td>
                        <span class="rounded-md" [ngClass]="getTagClass(tag)">
                          <input
                            id="{{ tag.fullPath }}"
                            [ngClass]="getColorClassFor(tag)"
                            class="!m-0 !border-{{
                              getTagColor(tag, newTags)
                            }}-400 {{
                              tag.isArchived ? 'cursor-not-allowed' : ''
                            }} {{ isTopLevel(tag) ? '!rounded-r-none' : '' }}"
                            type="text"
                            placeholder="Tag name..."
                            *ngIf="!tag.isArchived"
                            [value]="
                              tag.isArchived
                                ? tag.fullPath
                                : tag.fullPath.split('/').splice(-1)
                            "
                            (input)="updateNameAndChildrenName(tag, $event)"
                          />
                          <span *ngIf="tag.isArchived">{{ tag.fullPath }}</span>
                        </span>
                        <select
                          matTooltip="Color"
                          class="grow h-[32px] cursor-pointer !border-{{
                            getTagColor(tag, newTags)
                          }}-400 !border-x-0 !rounded-none"
                          *ngIf="isTopLevel(tag) && !tag.isArchived"
                          [value]="tag.color || 'green'"
                          [ngClass]="getColorClassFor(tag)"
                          (change)="updateColor(tag, $event)"
                          name="color"
                          id="color"
                        >
                          <option value="green">🟢</option>
                          <option value="orange">🟠</option>
                          <option value="red">
                            {{ authService.isPro ? "🔴" : "🔴 (Pro)" }}
                          </option>
                          <option value="blue">
                            {{ authService.isPro ? "🔵" : "🔵 (Pro)" }}
                          </option>
                          <option value="yellow">
                            {{ authService.isPro ? "🟡" : "🟡 (Pro)" }}
                          </option>
                          <option value="purple">
                            {{ authService.isPro ? "🟣" : "🟣 (Pro)" }}
                          </option>

                          <option value="white">
                            {{ authService.isPro ? "⚪" : "⚪ (Pro)" }}
                          </option>
                        </select>
                        <mat-form-field
                          matTooltip="Summary type"
                          *ngIf="isTopLevel(tag)"
                          class="w-[70px] h-[32px] {{
                            getColorClassFor(tag)
                          }} {{ getTagColor(tag, newTags) }} translate-y-[3px]"
                        >
                          <mat-select
                            (selectionChange)="updateSummary(tag, $event)"
                            panelClass="wide-panel {{
                              getTagColor(tag, newTags)
                            }} !border-{{ getTagColor(tag, newTags) }}-400"
                            [value]="tag?.summary?.toString() ?? 'none'"
                          >
                            <mat-select-trigger class="!w-[40px]"
                              ><mat-icon class="translate-y-[4px]">
                                {{ getSummaryIcon(tag, newTags) }}
                              </mat-icon></mat-select-trigger
                            >
                            <mat-option [value]="'expenditureProgress'">
                              <div class="py-2 flex">
                                <mat-icon
                                  class="align-middle translate-y-[5px]"
                                >
                                  shopping_bag
                                </mat-icon>
                                <div>
                                  <span class="block font-medium"
                                    >Expenditure progress</span
                                  >
                                  <span
                                    >Plan and track your expenditure. Ideal for
                                    budgets.</span
                                  >
                                </div>
                              </div>
                            </mat-option>
                            <mat-option [value]="'incomeProgress'">
                              <div class="py-2 flex">
                                <mat-icon
                                  class="align-middle translate-y-[5px]"
                                >
                                  savings
                                </mat-icon>
                                <div>
                                  <span class="block font-medium"
                                    >Income progress</span
                                  >
                                  <span
                                    >Plan and track your income. Ideal for
                                    businesses.</span
                                  >
                                </div>
                              </div>
                            </mat-option>
                            <mat-option [value]="'runningBalance'">
                              <div class="py-2 flex">
                                <mat-icon
                                  class="align-middle translate-y-[5px]"
                                >
                                  balance
                                </mat-icon>
                                <div>
                                  <span class="block font-medium"
                                    >Running balance</span
                                  >
                                  <span
                                    >Track your running balance. Ideal for
                                    accounts.</span
                                  >
                                </div>
                              </div>
                            </mat-option>
                            <mat-option [value]="'none'">
                              <div class="py-2 flex">
                                <mat-icon
                                  class="align-middle translate-y-[5px]"
                                >
                                  tag
                                </mat-icon>
                                <div>
                                  <span class="block font-medium"
                                    >No summary</span
                                  >
                                  <span>Keep calm and stay quiet</span>
                                </div>
                              </div>
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </td>

                      <td class="text-center">
                        <!-- Expenditure input -->

                        <div
                          class="text-center"
                          [hidden]="
                            getTagSummary(tag, newTags) !==
                              'expenditureProgress' || tag.isArchived
                          "
                        >
                          <input
                            id="planned-expenditure-{{ tag.id }}"
                            type="text"
                            placeholder="Planned expenditure"
                            [value]="
                              getTagPeriod(tag)?.plannedExpenditure || null
                            "
                            (input)="updatePlanned(tag, $event)"
                          />
                        </div>

                        <!-- Income input -->
                        <div
                          [hidden]="
                            getTagSummary(tag, newTags) !== 'incomeProgress' ||
                            tag.isArchived
                          "
                        >
                          <!-- <div [hidden]="true"> -->
                          <input
                            id="planned-income-{{ tag.id }}"
                            type="text"
                            placeholder="Planned income"
                            [value]="getTagPeriod(tag)?.plannedIncome || null"
                            (input)="updatePlanned(tag, $event)"
                          />
                        </div>
                        <span
                          class="text-gray-400 text-center"
                          *ngIf="
                            !tag.isArchived &&
                            (!getTopLevelTag(tag)?.summary ||
                              getTopLevelTag(tag)?.summary === 'none' ||
                              getTopLevelTag(tag)?.summary === 'runningBalance')
                          "
                        >
                          <span class="text-center">Nothing to plan</span>
                        </span>
                      </td>

                      <td>
                        <!-- Expenditure progress -->
                        <span
                          *ngIf="true"
                          [hidden]="
                            !hasChildren(tag) ||
                            tag.fullPath === '' ||
                            getTagSummary(tag, newTags) !==
                              'expenditureProgress'
                          "
                          class="text-gray-400 text-xs"
                          [ngClass]="{
                            'text-orange-500':
                              getChildrenTotal(tag) > getPlannedExpenditure(tag)
                          }"
                          ><span
                            class="max-w-[9rem] truncate inline-block align-middle"
                            matTooltip="The total sum of subtag plans"
                          >
                            <span
                              (click)="
                                setPeriodicPlannedExpenditure(
                                  tag,
                                  getChildrenTotal(tag)
                                )
                              "
                              [ngClass]="{
                                'underline cursor-pointer decoration-dashed':
                                  getChildrenTotal(tag) >
                                  getPlannedExpenditure(tag)
                              }"
                              >Subtag total:
                              {{
                                getChildrenTotal(tag) | prefundCurrency
                              }}</span
                            ></span
                          ></span
                        >

                        <!-- INcome progress -->
                        <span
                          [hidden]="
                            !hasChildren(tag) ||
                            tag.fullPath === '' ||
                            getTagSummary(tag, newTags) !== 'incomeProgress'
                          "
                          class="text-gray-400 text-xs"
                          [ngClass]="{
                            'text-orange-500':
                              getChildrenTotal(tag) > getPlannedIncome(tag)
                          }"
                          ><span
                            class="max-w-[9rem] truncate inline-block align-middle"
                            matTooltip="The total sum of subtag plans"
                          >
                            <span
                              (click)="
                                setPeriodicPlannedIncome(
                                  tag,
                                  getChildrenTotal(tag)
                                )
                              "
                              [ngClass]="{
                                'underline cursor-pointer decoration-dashed':
                                  getChildrenTotal(tag) > getPlannedIncome(tag)
                              }"
                            >
                              Subtag total:
                              {{ getChildrenTotal(tag) | number : "." }}</span
                            ></span
                          ></span
                        >
                      </td>

                      <td class="flex justify-end">
                        <mat-icon
                          class="text-gray-400 cursor-pointer mr-2"
                          matTooltip="Add subtag"
                          (click)="addChild(tag, true)"
                          >add</mat-icon
                        >
                        <mat-icon
                          class="text-gray-400 cursor-pointer mr-2"
                          matTooltip="Move up"
                          (click)="moveUp(tag)"
                          >arrow_upward</mat-icon
                        >
                        <mat-icon
                          class="text-gray-400 cursor-pointer mr-2"
                          matTooltip="Move down"
                          (click)="moveDown(tag)"
                          >arrow_downward</mat-icon
                        >
                        <mat-icon
                          matTooltip="Toggle visibility for period"
                          class="text-gray-400 cursor-pointer mr-2"
                          (click)="toggleVisibility(tag)"
                          >{{
                            isVisible(tag) ? "visibility" : "visibility_off"
                          }}</mat-icon
                        >

                        <mat-icon
                          class="text-gray-400 cursor-pointer"
                          [matMenuTriggerFor]="menu"
                          matTooltip="More"
                          >more_vert</mat-icon
                        >
                        <mat-menu #menu="matMenu">
                          <button
                            mat-menu-item
                            (click)="duplicate(tag)"
                            *ngIf="!tag.isArchived && tag.id"
                          >
                            <mat-icon>content_copy</mat-icon> Duplicate
                          </button>
                          <button
                            mat-menu-item
                            (click)="archive(tag)"
                            *ngIf="!tag.isArchived"
                          >
                            <mat-icon>archive</mat-icon> Archive
                          </button>
                          <button
                            mat-menu-item
                            (click)="archive(tag, false)"
                            *ngIf="tag.isArchived"
                          >
                            <mat-icon>unarchive</mat-icon> Unarchive
                          </button>
                          <button mat-menu-item (click)="deleteTag(tag)">
                            <mat-icon>delete</mat-icon> Delete
                          </button>
                        </mat-menu>
                      </td>
                    </tr>
                  </ng-content>

                  <tr
                    *ngIf="
                      expandPeriodicTags &&
                      getPeriodicNewTags(newTags).length > 0
                    "
                  >
                    <td class="p-10">
                      <span
                        class="cursor-pointer text-blue-500"
                        (click)="addTag(true)"
                        >New Periodic Tag...
                      </span>
                    </td>
                  </tr>
                </ng-content>
              </tbody>
            </table>

            <planner-empty-state
              *ngIf="
                expandPeriodicTags && getPeriodicNewTags(newTags).length === 0
              "
              [title]="'Create a Periodic Tag'"
              [description]="'Periodic Tags have periodic summaries.'"
              [descriptionSecondLine]="
                'Ideal for monthly budgets or income goals.'
              "
              [callToActionText]="'New Periodic Tag...'"
              (callToActionClick)="addTag(true)"
            ></planner-empty-state>

            <table class="w-full border-separate border-spacing-0">
              <tbody>
                <tr
                  class="uppercase bg-gray-100 hover:bg-gray-200 text-gray-500"
                >
                  <td
                    class="border-y min-w-[{{
                      defaultCellWidth
                    }}] cursor-pointer"
                    (click)="toggleArchivedTags()"
                  >
                    <mat-icon class="align-middle" *ngIf="expandArchivedTags"
                      >keyboard_arrow_down</mat-icon
                    >
                    <mat-icon class="align-middle" *ngIf="!expandArchivedTags"
                      >keyboard_arrow_up</mat-icon
                    >
                    <span class="align-middle mr-4">Archived tags</span>
                    <pro-badge *ngIf="!authService.isPro"></pro-badge>
                  </td>
                  <td
                    class="border-y text-center min-w-[{{ defaultCellWidth }}]"
                  >
                    <span
                      *ngIf="
                        expandArchivedTags &&
                        getArchivedNewTags(newTags).length > 0
                      "
                      >Type</span
                    >
                  </td>
                  <td class="min-w-[{{ defaultMiniCellWidth }}]"></td>
                  <td class="border-y text-center">
                    <span
                      *ngIf="
                        expandArchivedTags &&
                        getArchivedNewTags(newTags).length > 0
                      "
                      >Actions</span
                    >
                  </td>
                </tr>
                <ng-content *ngIf="expandArchivedTags">
                  <ng-content
                    *ngFor="
                      let tag of getArchivedNewTags(newTags);
                      trackBy: trackByTagId
                    "
                  >
                    <tr>
                      <td>
                        <div class="p-1">
                          <span class="tag" [ngClass]="getColorClassFor(tag)">{{
                            tag.fullPath
                          }}</span>
                        </div>
                      </td>
                      <td class="text-center">
                        {{ tag.isPeriodic ? "Periodic" : "Fixed" }}
                      </td>
                      <td></td>
                      <td class="flex justify-end">
                        <mat-icon
                          class="text-gray-400 cursor-pointer mr-2"
                          matTooltip="Unarchive"
                          (click)="archive(tag, false)"
                          >unarchive</mat-icon
                        >
                        <mat-icon
                          class="text-gray-400 cursor-pointer mr-2"
                          matTooltip="Delete"
                          (click)="deleteTag(tag)"
                          >delete</mat-icon
                        >
                      </td>
                    </tr>
                  </ng-content></ng-content
                >
              </tbody>
            </table>
            <planner-empty-state
              *ngIf="
                expandArchivedTags && getArchivedNewTags(newTags).length === 0
              "
              [title]="'Get started with Archived Tags'"
              [description]="
                'Archived Tags are hidden from the sidebar and autocomplete, but they remain present on Entries and in the Planner.'
              "
            ></planner-empty-state>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
